import { render, staticRenderFns } from "./AbsenceRegistrations.vue?vue&type=template&id=13a5f637&scoped=true&"
import script from "./AbsenceRegistrations.vue?vue&type=script&lang=js&"
export * from "./AbsenceRegistrations.vue?vue&type=script&lang=js&"
import style0 from "./AbsenceRegistrations.vue?vue&type=style&index=0&id=13a5f637&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a5f637",
  null
  
)

component.options.__file = "AbsenceRegistrations.vue"
export default component.exports